import * as api from "../../api";
import { buildAlertWithLocalizedMessages } from "..";
import { jsError } from "../../common/utils";
/* export * from "./authentication"; */

export const getContractCount = personNr => {
  return dispatch => {
    dispatch({ type: "GET_CONTRACT_COUNT_LOADING" });
    api
      .contractCountGet(personNr)
      .then(resp => {
        dispatch(operationSucceeded(resp.data));
      })
      .catch(e => {
        jsError(e);
        dispatch(operationFail());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "FetchContractCountAlertTitle",
          "Virhe henkilön työsopimusten lukumäärän noutamisessa",
          e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

const operationSucceeded = data => ({
  type: "GET_CONTRACT_COUNT_SUCCEEDED",
  payload: { contractCount: data },
});

const operationFail = () => ({
  type: "GET_CONTRACT_COUNT_FAIL",
});
